import styles from './file-info.module.css'

export const getExtensionClasses = (extension: string): string => {
  const style = `${styles.extension}`

  const isPdf = ['pdf'].includes(extension)
  const isXml = ['xml'].includes(extension)
  const isImg = ['jpg', 'jpeg', 'png', 'gif'].includes(extension)

  if (isPdf) {
    return `${style} ${styles.pdf}`
  }
  if (isXml) {
    return `${style} ${styles.xml}`
  }
  if (isImg) {
    return `${style} ${styles.img}`
  }

  return style
}
